/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ResultOfBrokerConsultantInformationViewModel,
  ResultOfListOfIAPIntermediaryDetailsViewModel,
  ResultOfListOfIntermediaryAssociatesViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfBrokerConsultantInformationViewModelFromJSON,
    ResultOfBrokerConsultantInformationViewModelToJSON,
    ResultOfListOfIAPIntermediaryDetailsViewModelFromJSON,
    ResultOfListOfIAPIntermediaryDetailsViewModelToJSON,
    ResultOfListOfIntermediaryAssociatesViewModelFromJSON,
    ResultOfListOfIntermediaryAssociatesViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface IntermediaryGetIAPIntermediaryDetailsRequest {
    intermediaryCode: string;
}

export interface IntermediaryGetIntermediaryAssociatesRequest {
    intermediaryCode: string;
}

export interface IntermediaryGetIntermediaryConsultantsRequest {
    externalUserId: string;
}

export interface IntermediaryGetIntermediaryProxyRequest {
    externalUserId: string;
}

/**
 * 
 */
export class IntermediaryApi extends runtime.BaseAPI {

    /**
     * Get Intermediary details from IAP.
     */
    async intermediaryGetIAPIntermediaryDetailsRaw(requestParameters: IntermediaryGetIAPIntermediaryDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfIAPIntermediaryDetailsViewModel>> {
        if (requestParameters.intermediaryCode === null || requestParameters.intermediaryCode === undefined) {
            throw new runtime.RequiredError('intermediaryCode','Required parameter requestParameters.intermediaryCode was null or undefined when calling intermediaryGetIAPIntermediaryDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/iap-intermediaries/{intermediaryCode}/intermediaryDetails`.replace(`{${"intermediaryCode"}}`, encodeURIComponent(String(requestParameters.intermediaryCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfIAPIntermediaryDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get Intermediary details from IAP.
     */
    async intermediaryGetIAPIntermediaryDetails(requestParameters: IntermediaryGetIAPIntermediaryDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfIAPIntermediaryDetailsViewModel> {
        const response = await this.intermediaryGetIAPIntermediaryDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get associates intermediary information for the provided intermediary code
     */
    async intermediaryGetIntermediaryAssociatesRaw(requestParameters: IntermediaryGetIntermediaryAssociatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfIntermediaryAssociatesViewModel>> {
        if (requestParameters.intermediaryCode === null || requestParameters.intermediaryCode === undefined) {
            throw new runtime.RequiredError('intermediaryCode','Required parameter requestParameters.intermediaryCode was null or undefined when calling intermediaryGetIntermediaryAssociates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/intemediaries/{intermediaryCode}/associates`.replace(`{${"intermediaryCode"}}`, encodeURIComponent(String(requestParameters.intermediaryCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfIntermediaryAssociatesViewModelFromJSON(jsonValue));
    }

    /**
     * Get associates intermediary information for the provided intermediary code
     */
    async intermediaryGetIntermediaryAssociates(requestParameters: IntermediaryGetIntermediaryAssociatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfIntermediaryAssociatesViewModel> {
        const response = await this.intermediaryGetIntermediaryAssociatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get intermediary consultants information for the provided code
     */
    async intermediaryGetIntermediaryConsultantsRaw(requestParameters: IntermediaryGetIntermediaryConsultantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBrokerConsultantInformationViewModel>> {
        if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
            throw new runtime.RequiredError('externalUserId','Required parameter requestParameters.externalUserId was null or undefined when calling intermediaryGetIntermediaryConsultants.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/consultants/{externalUserId}/intermediaries`.replace(`{${"externalUserId"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBrokerConsultantInformationViewModelFromJSON(jsonValue));
    }

    /**
     * Get intermediary consultants information for the provided code
     */
    async intermediaryGetIntermediaryConsultants(requestParameters: IntermediaryGetIntermediaryConsultantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBrokerConsultantInformationViewModel> {
        const response = await this.intermediaryGetIntermediaryConsultantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get intermediary proxy information for the provided code
     */
    async intermediaryGetIntermediaryProxyRaw(requestParameters: IntermediaryGetIntermediaryProxyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBrokerConsultantInformationViewModel>> {
        if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
            throw new runtime.RequiredError('externalUserId','Required parameter requestParameters.externalUserId was null or undefined when calling intermediaryGetIntermediaryProxy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/intermediaryProxies/{externalUserId}/intermediaries`.replace(`{${"externalUserId"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBrokerConsultantInformationViewModelFromJSON(jsonValue));
    }

    /**
     * Get intermediary proxy information for the provided code
     */
    async intermediaryGetIntermediaryProxy(requestParameters: IntermediaryGetIntermediaryProxyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBrokerConsultantInformationViewModel> {
        const response = await this.intermediaryGetIntermediaryProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
